var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "product-slider-card"
  }, [_vm.labelText ? _c('div', {
    staticClass: "product-slider-card__label"
  }, [_c('p', {
    staticClass: "label__text"
  }, [_vm._v(_vm._s(_vm.labelText))])]) : _vm._e(), _vm._v(" "), _c('div', {
    ref: "slider",
    staticClass: "product-slider-card__slider"
  }, [_c('div', {
    staticClass: "constructor-swiper-wrapper"
  }, _vm._l(_vm.items, function (el, index) {
    var _el$image, _el$image2, _el$image3;

    return _c('div', {
      key: index,
      staticClass: "product-slider-card__slide constructor-swiper-slide"
    }, [_c('GGLink', {
      staticClass: "product-slider-card__slide",
      attrs: {
        "to": el.path
      }
    }, [_c('img', {
      staticClass: "slide__img",
      attrs: {
        "src": (_el$image = el.image) === null || _el$image === void 0 ? void 0 : _el$image.x1,
        "srcset": ((_el$image2 = el.image) === null || _el$image2 === void 0 ? void 0 : _el$image2.x2) && (((_el$image3 = el.image) === null || _el$image3 === void 0 ? void 0 : _el$image3.x2) + " 2x"),
        "alt": el.name
      }
    })])], 1);
  }), 0)]), _vm._v(" "), _vm.promocode ? _c('div', {
    staticClass: "product-slider-card__promocode"
  }, [_c('p', {
    staticClass: "promocode__title"
  }, [_vm._v("По промокоду")]), _vm._v(" "), _c('GGPromoButton', {
    attrs: {
      "text": _vm.promocode,
      "color": _vm.promocodeColor
    }
  })], 1) : _vm._e()]);
}
var staticRenderFns = []

export { render, staticRenderFns }